import DentistryIcon from './DentistryIcon';
import DermatovenerologyIcon from './DermatovenerologyIcon';
import ObstetricsGynaecologyIcon from './ObstetricsGynaecologyIcon';
import InternalMedicineIcon from './InternalMedicineIcon';
import UrologyIcon from './UrologyIcon';
import PediatricsIcon from './PediatricsIcon';
import NeonatologyIcon from './NeonatologyIcon';
import GastroenterologyIcon from './GastroenterologyIcon';
import PediatricGastroenterologyIcon from './PediatricGastroenterologyIcon';
import CardiologyIcon from './CardiologyIcon';
import PediatricCardiologyIcon from './PediatricCardiologyIcon';
import OtolaryngologyEntIcon from './OtolaryngologyEntIcon';
import HematologyIcon from './HematologyIcon';
import LaboratoryMedicineIcon from './LaboratoryMedicineIcon';
import PulmonologyIcon from './PulmonologyIcon';
import PediatricPulmonologyIcon from './PediatricPulmonologyIcon';
import NephrologyIcon from './NephrologyIcon';
import PediatricNephrologyIcon from './PediatricNephrologyIcon';
import NeurologyIcon from './NeurologyIcon';
import PediatricNeurologyIcon from './PediatricNeurologyIcon';
import NeurosurgeryIcon from './NeurosurgeryIcon';
import RadiotherapyIcon from './RadiotherapyIcon';
import RadiologyAndMedicalImagingIcon from './RadiologyAndMedicalImagingIcon';
import OncologyIcon from './OncologyIcon';
import PediatricOncologyAndHematologyIcon from './PediatricOncologyAndHematologyIcon';
import OrthopedicsAndTraumatologyIcon from './OrthopedicsAndTraumatologyIcon';
import PediatricOrthopedicsIcon from './PediatricOrthopedicsIcon';
import MedicalRecoveryIcon from './MedicalRecoveryIcon';
import InfectiousDiseasesIcon from './InfectiousDiseasesIcon';
import EndocrinologyIcon from './EndocrinologyIcon';
import AllergologyAndClinicalImmunologyIcon from './AllergologyAndClinicalImmunologyIcon';
import DiabetesNutritionAndMetabolicDiseasesIcon from './DiabetesNutritionAndMetabolicDiseasesIcon';

import EmergencyMedicineIcon from './EmergencyMedicineIcon';
import SportsMedicineIcon from './SportsMedicineIcon';
import GeneralSurgeryIcon from './GeneralSurgeryIcon';
import VascularSurgeryIcon from './VascularSurgeryIcon';
import CardiovascularSurgeryIcon from './CardiovascularSurgeryIcon';
import PlasticSurgeryReconstructiveMicrosurgeryIcon from './PlasticSurgeryReconstructiveMicrosurgeryIcon';
import PediatricSurgeryIcon from './PediatricSurgeryIcon';
import ThoracicSurgeryIcon from './ThoracicSurgeryIcon';
import OphthalmologyIcon from './OphthalmologyIcon';
import RheumatologyIcon from './RheumatologyIcon';
import FamilyMedicineIcon from './FamilyMedicineIcon';
import GeneralMedicineIcon from './GeneralMedicineIcon';
import AnesthesiaAndIntensiveCareIcon from './AnesthesiaAndIntensiveCareIcon';
import PsychiatryIcon from './PsychiatryIcon';
import PediatricPsychiatryIcon from './PediatricPsychiatryIcon';
import PsychologyIcon from './PsychologyIcon';
import PathologicalAnatomyIcon from './PathologicalAnatomyIcon';
import OralAndMaxillofacialSurgeryIcon from './OralAndMaxillofacialSurgeryIcon';
import OrthodonticsIcon from './OrthodonticsIcon';
import MedicalGeneticsIcon from './MedicalGeneticsIcon';
import MedicalExpertiseIcon from './MedicalExpertiseIcon';
import GeriatricsAndGerontologyIcon from './GeriatricsAndGerontologyIcon';

const index = {
  'internal-medicine-icon': InternalMedicineIcon,
  'dermatovenerology-icon': DermatovenerologyIcon,
  'obstetrics-gynaecology-icon': ObstetricsGynaecologyIcon,
  'urology-icon': UrologyIcon,
  'pediatrics-icon': PediatricsIcon,
  'neonatology-icon': NeonatologyIcon,
  'gastroenterology-icon': GastroenterologyIcon,
  'pediatric-gastroenterology-icon': PediatricGastroenterologyIcon,
  'cardiology-icon': CardiologyIcon,
  'pediatric-cardiology-icon': PediatricCardiologyIcon,
  'otolaryngology-ent-icon': OtolaryngologyEntIcon,
  'hematology-icon': HematologyIcon,
  'laboratory-medicine-icon': LaboratoryMedicineIcon,
  'pulmonology-icon': PulmonologyIcon,
  'pediatric-pulmonology-icon': PediatricPulmonologyIcon,
  'nephrology-icon': NephrologyIcon,
  'pediatric-nephrology-icon': PediatricNephrologyIcon,
  'neurology-icon': NeurologyIcon,
  'pediatric-neurology-icon': PediatricNeurologyIcon,
  'neurosurgery-icon': NeurosurgeryIcon,
  'radiotherapy-icon': RadiotherapyIcon,
  'radiology-and-medical-imaging-icon': RadiologyAndMedicalImagingIcon,
  'oncology-icon': OncologyIcon,
  'pediatric-oncology-and-hematology-icon': PediatricOncologyAndHematologyIcon,
  'orthopedics-and-traumatology-icon': OrthopedicsAndTraumatologyIcon,
  'pediatric-orthopedics-icon': PediatricOrthopedicsIcon,
  'medical-recovery-icon': MedicalRecoveryIcon,
  'infectious-diseases-icon': InfectiousDiseasesIcon,
  'endocrinology-icon': EndocrinologyIcon,
  'allergology-and-clinical-immunology-icon': AllergologyAndClinicalImmunologyIcon,
  'diabetes-nutrition-and-metabolic-diseases-icon': DiabetesNutritionAndMetabolicDiseasesIcon,
  'general-surgery-icon': GeneralSurgeryIcon,
  'vascular-surgery-icon': VascularSurgeryIcon,
  'cardiovascular-surgery-icon': CardiovascularSurgeryIcon,
  'plastic-surgery-reconstructive-microsurgery-icon': PlasticSurgeryReconstructiveMicrosurgeryIcon,
  'pediatric-surgery-icon': PediatricSurgeryIcon,
  'thoracic-surgery-icon': ThoracicSurgeryIcon,
  'ophthalmology-icon': OphthalmologyIcon,
  'rheumatology-icon': RheumatologyIcon,
  'family-medicine-icon': FamilyMedicineIcon,
  'general-medicine-icon': GeneralMedicineIcon,
  'anesthesia-and-intensive-care-icon': AnesthesiaAndIntensiveCareIcon,
  'psychiatry-icon': PsychiatryIcon,
  'pediatric-psychiatry-icon': PediatricPsychiatryIcon,
  'psychology-icon': PsychologyIcon,
  'pathological-anatomy-icon': PathologicalAnatomyIcon,
  'oral-and-maxillofacial-surgery-icon': OralAndMaxillofacialSurgeryIcon,
  'orthodontics-icon': OrthodonticsIcon,
  'dentistry-icon': DentistryIcon,
  'medical-genetics-icon': MedicalGeneticsIcon,
  'geriatrics-and-gerontology-icon': GeriatricsAndGerontologyIcon,
  'medical-expertise-icon': MedicalExpertiseIcon,
  'sports-medicine-icon': SportsMedicineIcon,
  'emergency-medicine-icon': EmergencyMedicineIcon
};

export default index;
